import React, { useState, useEffect } from 'react'
import '../../App.css'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'
import { formatZARCurrency } from '../../MoneyFormat'
import { API_URL } from '../../config'
// import "./PayoutRequestList.css"; // Optional styling

const PayoutRequestList = ({ eventid, count, setRefreshing, source }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [requests, setRequests] = useState([])
  const [clipLoading, setClipLoading] = useState(true)
  const baseURL = `${API_URL}/apps/kscanner/webservices.php`
  const sitURL = API_URL

  // let query = "";
  // if (source === "partnerPayout") {
  //   query = "PAYOUT-REQUEST-LIST-PARTNERS";
  // } else {
  //   query = "PAYOUT-REQUEST-LIST";
  // }
  useEffect(() => {
    Axios.get(`${baseURL}?query=PAYOUT-REQUEST-LIST&event_id=${eventid}`, {
      withCredentials: true,
    }).then((response) => {
      setRefreshing('')
      setClipLoading(false)
      const res = response.data
      console.log(res.length)
      if (res.length === 0) {
        setRequests([])
      } else {
        setRequests(res)
      }
    })
  }, [count])

  const totalRequested = requests.reduce((sum, req) => {
    return sum + parseFloat(req.amount_requested)
  }, 0)

  const totalPaid = requests.reduce((sum, req) => {
    return sum + parseFloat(req.amount_paid)
  }, 0)

  const totalPayFees = requests.reduce((sum, req) => {
    return sum + parseFloat(req.payout_fee)
  }, 0)

  return (
    <div className="accordion-item">
      <label
        onClick={() => setIsOpen(!isOpen)}
        className="accordion-header me-auto text-bold text-dark cursor-pointer w-auto"
      >
        <span>Payout Activity</span> {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        <br />
        <span className="font-size-14 font-normal cursor-pointer">
          View all your payout activities.
        </span>
      </label>
      {isOpen && (
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr className="font-size-14">
                <th>Date</th>
                <th>Payout Type</th>
                <th>Amount Requested</th>
                <th>Amount Paid</th>
                <th>Payout Fee</th>
                <th>Status</th>
                <th>Reference</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {clipLoading ? (
                <tr>
                  <td colSpan={6} className="text-center">
                    <ClipLoader size={25} color="grey" />
                  </td>
                </tr>
              ) : (
                <>
                  {requests.length === 0 ? (
                    <tr>
                      <td colSpan={6}>No payout requests found.</td>
                    </tr>
                  ) : (
                    <>
                      {requests.map((req) => (
                        <tr key={req.payout_id} className="font-size-14">
                          <td>{new Date(req.created_at).toLocaleDateString()}</td>
                          <td>{req.payout_type}</td>
                          <td>{formatZARCurrency(req.amount_requested.toString())}</td>
                          <td>{formatZARCurrency(req.amount_paid.toString())}</td>
                          <td>{formatZARCurrency(req.payout_fee.toString())}</td>
                          <td>
                            <label className={`status-badg`}>{req.payout_status}</label>
                          </td>
                          <td>{req.audit_token}</td>
                          <td>
                            {req.payout_status == 'Verification' ? (
                              <label>🟡 Funds are reserved while Ozow verifies.</label>
                            ) : req.payout_status == 'SubmittedForProcessing' ? (
                              <label>🟡Funds are in transit.</label>
                            ) : req.payout_status == 'PayoutPendingInvestigation' ? (
                              <label>🟡Funds are locked until investigation resolves.</label>
                            ) : req.payout_status == 'PayoutComplete' ? (
                              <label>🟢 Funds have been paid out.</label>
                            ) : req.payout_status == 'PayoutReceived' ? (
                              <label>🟢 Funds have been paid out.</label>
                            ) : req.payout_status == 'PayoutCancelled' ? (
                              <label>🔴 Request failed, funds returned to net.</label>
                            ) : req.payout_status == 'VerificationFailed' ? (
                              <label>🔴 Request rejected, funds return.</label>
                            ) : req.payout_status == 'PayoutProcessingError' ? (
                              <label>🔴 Error, funds return.</label>
                            ) : (
                              <label>🔴 Funds returned to net.</label>
                            )}
                            {/* {!req.file_url ? (
                              <label className="font-medium">Pending</label>
                            ) : (
                              <a
                                href={`${sitURL}/apps/kscanner/payments/${req.eventId}/${req.file_url}`}
                                target="_blank"
                                className="color-blue"
                              >
                                {req.file_url}
                              </a>
                            )} */}
                          </td>
                        </tr>
                      ))}
                      <tr className="font-size-14">
                        <td colSpan={5} className="text-right">
                          {/* <span>Total</span> */}
                        </td>
                        <td className="text-left">
                          <span>Requested:</span> {formatZARCurrency(totalRequested.toString())}
                        </td>
                        <td className="text-left">
                          <span>Paid:</span> {formatZARCurrency(totalPaid.toString())}
                        </td>
                        <td className="text-left">
                          <span>Payout Fees:</span> {formatZARCurrency(totalPayFees.toString())}
                        </td>
                      </tr>
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default PayoutRequestList
